const style = (): any => ({
    root: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: 100,
    },
    buttonContainer: {
        margin: 20,
    },
});
export default style;
